import { useContext } from 'react';
import { useState } from 'react';
import AuthContext from '../../store/auth-context';
import Button from '../ui/Button';
import { useNavigate } from 'react-router-dom';

import './UserProfileInfo.scss';
import EditUserProfile from './EditUserProfile';

const UserProfileInfo = () => {
	const [editProfileIsActive, setEditProfileIsActive] =
		useState(true);

	const authCtx = useContext(AuthContext);
	const navigate = useNavigate();

	const userLogoutHandler = () => {
		authCtx.logout();
		navigate('/login');
	};

	const edituserProfileHandler = () => {
		setEditProfileIsActive(!editProfileIsActive);
	};

	const editProfileButtonLable = editProfileIsActive
		? 'Edit Profile'
		: 'Cancel';

	const editProfileButtonIcon = editProfileIsActive
		? 'edit'
		: 'cancel';

	return (
		<div className='profile-container'>
			<div className='profile-header-container'>
				<h2>My Profile</h2>
				<div className='profile-header-container'>
					<Button
						className='secondary-button'
						startIcon={editProfileButtonIcon}
						onClick={edituserProfileHandler}
					>
						{editProfileButtonLable}
					</Button>
					<Button
						className='primary-button'
						startIcon='logout'
						onClick={userLogoutHandler}
					>
						Log out
					</Button>
				</div>
			</div>
			{editProfileIsActive ? (
				<div className='profile-data-container'>
					<div>
						<div className='user-data-item'>
							<h5>
								{authCtx.userData.firstname}{' '}
								{authCtx.userData.lastname}
							</h5>
							<p className='user-data-item-info'>
								{authCtx.userData.role}
							</p>
						</div>
					</div>
					<div className='profile-user-data'>
						<div className='user-data-item'>
							<h5>Email Address</h5>
							<p className='user-data-item-info'>
								{authCtx.userData.email}
							</p>
						</div>
						<div className='user-data-item'>
							<h5>Phone Number</h5>
							<p className='user-data-item-info'>
								{authCtx.userData.phone ||
									'+1 1234 66575'}
							</p>
						</div>
						<div className='user-data-item'>
							<h5>Headquarters</h5>
							<p className='user-data-item-info'>
								{authCtx.userData.department ||
									'3857 Whispering Pines Circle'}
							</p>
						</div>
					</div>
				</div>
			) : (
				<EditUserProfile
					username={authCtx.userData}
					email={authCtx.userData.email}
					headquarters={authCtx.userData.department}
					userId={authCtx.userData._id}
				/>
			)}
		</div>
	);
};

export default UserProfileInfo;
